module.exports = __webpack_public_path__ + "assets/images/pages/job/image-detail-2.png?31c077e4";